import { useMemo } from 'react';

import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetDemandedDocuments } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

const useOpenClaims = (id: string) => {
    const queryKey = queryKeys.getDemandedDocuments(id);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);
    const demandedDocuments = useAggregateQuery({
        acl: { loanRequestId: id },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getDemandedDocuments,
        schema: schemaLoanRequestResolver_GetDemandedDocuments,
        searchParams: { id, position: queryPosition },
    });

    const openClaims = useMemo(() => {
        return demandedDocuments.data?.documents ? demandedDocuments.data.documents : [];
    }, [demandedDocuments.data]);

    return { isError: demandedDocuments.isError, openClaims };
};

export default useOpenClaims;
